import React from "react";
import { Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import DrayageRouteGuard from "./DrayageRouteGuard";

const AppRoute = ({
  route,
  routeindex,
  isOrderPage,
  updateDisplayContext,
  filterPlaceHolder,
  searchType,
  handleChildFilterChange,
  handleAppStateOnChange,
  appContexts
}) => {
  // const { userContext, orgContext, warehouseContext } = appContexts;
  const fleetLite = appContexts?.orgContext?.currentOrg?.fleet_lite=="true";
 
  // Check if this is a Drayage route (route key starts with specific Drayage keys or path is a drayage path)
  const isDrayageRoute = route.parentKey === "drayage-menu" ||
                         route.key?.startsWith("drayage") ||
                         route.path?.startsWith("/loads") ||
                         route.path?.startsWith("/owners") ||
                         route.path?.startsWith("/types") ||
                         route.path?.startsWith("/equipment");

  const renderComponent = !isOrderPage
    ? (props) => <route.component { ...props } dispContext={ updateDisplayContext } appContexts={appContexts} handleAppStateOnChange={ handleAppStateOnChange } />
    : () => (
        <route.component
          filterPlaceHolder={
            filterPlaceHolder
          }
          appContexts={ appContexts }
          searchType={ searchType }
          handleChildFilterChange={
            handleChildFilterChange
          }
          handleAppStateOnChange={ handleAppStateOnChange }
          dispContext={ updateDisplayContext }
        />
      );

  const routeContent = (
    <ErrorBoundary key={ routeindex } fleetLite={ fleetLite ?? false }>
      <Route
        exact={ route.exact }
        path={ route.path }
        render={renderComponent}
        key={ route.key }
      />
    </ErrorBoundary>
  );

  // Wrap Drayage routes with the guard
  if (isDrayageRoute) {
    return <DrayageRouteGuard>{routeContent}</DrayageRouteGuard>;
  }

  return routeContent;
};


export default AppRoute;